<script>
    import { _ } from '../../services/i18n'
  </script>
  
  <section class="section-elements" >    
  <table class="table-elements">
      <tr>
        <td class="box-elements" id="r-box">
          <a href="#/tuto?/compositor/materials/cart">
           <h5>{$_('tutorial_materials_cart')}</h5>
           <div class="info-elements">  
              <p> Saber más </p>
              <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close"/> 
           </div>  
            <img id="element-elements" src="/icons/search.svg" alt="eye"/> 
          </a>
        </td>
        <td class="box-elements" id="y-box" >
          <a href="#/tuto?/compositor/materials/mattools">
          <h5>{$_('tutorial_materials_mattools')}</h5>
          <div class="info-elements">  
              <p> Saber más </p>
              <img id="user-elements" src="/icons/arrow-left-white.svg" alt="close"/> 
            </div>  
            <img id="element-elements" src="/icons/tools.svg" alt="search"/> 
          </a>
        </td>
      </tr>
    </table>
  
  </section>
  
  